export default __webpack_public_path__ + "static/media/img-bgCube.71949a46.svg";